export { GuestDetails as GuestDetailsV2 } from './GuestDetails';
